import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";

import BMXChatModal from "./../../../Components/BMXChatModal/BMXChatModal";
import ChatForm from "./../../Components/Forms/ChatForm/ChatForm";
import { useSelector } from "react-redux";

const ProjectChatModal = (props) => {
  const { handleHide, show, loadData, taskUuid } = props;
  const formName = "ProjectChatModal";
  const { t } = useTranslation();

  const { element } = props;

  const { projectTasks } = useSelector((state) => state.projectReducer);

  const subtask = projectTasks
    .find((t) => t.uuid === taskUuid)
    ?.subtasks?.find((s) => s.uuid === element.uuid);
  const comments = subtask?.comments || [];

  return (
    <BMXChatModal
      open={show}
      width={"500px"}
      height={"400px"}
      maxHeight={"500px"}
      onClose={handleHide}
      cancel="global:project.no"
      header={t("global:project.chat")}
      comments={comments}
      {...props}
    >
      <ChatForm
        {...props}
        formName={formName}
        handleHide={handleHide}
        loadData={loadData}
      />
    </BMXChatModal>
  );
};

export default connectModal({ name: "ProjectChatModal" })(ProjectChatModal);
